// extracted by mini-css-extract-plugin
module.exports = {"upgradeSendBody":"src-hellospa-components-prep-and-send-review-upgrade-modals__upgradeSendBody--2HZqc"};